module.exports = "https://static.energy5.com/_next/static/images/allSetImage-309df2119833936d551f42d24485516b.jpg";